// action types
import { createRequestTypes } from "../../utils";




// Fetch sub specialties
export const FETCH_SUBSPECIALTIES = createRequestTypes("FETCH_SUBSPECIALTIES");

export const fetchSubSpecialtiesRequest = () =>
    ({ type: FETCH_SUBSPECIALTIES.REQUEST });

export const fetchSubSpecialtiesSuccess = (subspecialties, count) =>
    ({ type: FETCH_SUBSPECIALTIES.SUCCESS, payload: { subspecialties, count } });

export const fetchSubSpecialtiesFailure = (error) =>
    ({ type: FETCH_SUBSPECIALTIES.FAILURE, payload: error });

// Clear sub specialties
export const CLEAR_SUBSPECIALTIES = createRequestTypes("CLEAR_SUBSPECIALTIES");

export const clearSubSpecialtyRequest = () =>
    ({ type: CLEAR_SUBSPECIALTIES.REQUEST });

export const clearSubSpecialtySuccess = (data) =>
    ({ type: CLEAR_SUBSPECIALTIES.SUCCESS, payload: { data } });

export const clearSubSpecialtyFailure = (error) =>
    ({ type: CLEAR_SUBSPECIALTIES.FAILURE, payload: error });




// Fetch Specialties
export const FETCH_SPECIALTIES = createRequestTypes("FETCH_SPECIALTIES");

export const fetchSpecialtiesRequest = () =>
    ({ type: FETCH_SPECIALTIES.REQUEST });

export const fetchSpecialtiesSuccess = (specialties, count) =>
    ({ type: FETCH_SPECIALTIES.SUCCESS, payload: { specialties, count } });

export const fetchSpecialtiesFailure = (error) =>
    ({ type: FETCH_SPECIALTIES.FAILURE, payload: { error } });

// Request Specialty
export const REQUEST_SPECIALTY = createRequestTypes("REQUEST_SPECIALTY");

export const requestSpecialtyRequest = (specialty, description) =>
    ({ type: REQUEST_SPECIALTY.REQUEST, payload: { specialty, description } });

export const requestSpecialtySuccess = () =>
    ({ type: REQUEST_SPECIALTY.SUCCESS });

export const requestSpecialtyFailure = (error) =>
    ({ type: REQUEST_SPECIALTY.FAILURE, payload: { error } });

// Clear Specialty Status
export const CLEAR_SPECIALTY_STATUS = createRequestTypes("CLEAR_SPECIALTY_STATUS");

export const clearSpecialtyStatusRequest = () =>
    ({ type: CLEAR_SPECIALTY_STATUS.REQUEST });

export const clearSpecialtyStatusSuccess = () =>
    ({ type: CLEAR_SPECIALTY_STATUS.SUCCESS });